import React, { useContext } from "react";
import { Box, Link, Divider } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { notificationContext } from "../../NotificationHIstory";
import { NormalText, BigHeadline } from "../../../../components/TextParts";

export default function NotificationList() {
  const { notificationList = [] } = useContext(notificationContext);

  return (
    <Box>
      <BigHeadline text="過去のお知らせ" />
      <Link component={RouterLink} to="/dashboard" sx={{ display: "inline-block", mb: 2 }}>
        戻る
      </Link>
      
      {notificationList.map((data, index) => (
        <Box key={data.id || index}>
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              gap: { xs: "10px", sm: "20px" },
              py: "10px",
            }}
          >
            <Box sx={{ display: "flex", gap: "20px" }}>
              <Box
                sx={{
                  width: "80px",
                  height: "22px",
                  flexShrink: 0,
                }}
              >
                <NormalText text={data.created_at?.substring(0, 10) || ""} />
              </Box>
              <Box
                sx={{
                  display: "inline-block",
                  width: "80px",
                  backgroundColor: "#d4d6df",
                  height: "22px",
                  borderRadius: 1,
                  textAlign: "center",
                  flexShrink: 0,
                }}
              >
                <NormalText text={data.condition || ""} />
              </Box>
            </Box>
            <NormalText text={data.note || ""} />
          </Box>
          <Divider sx={{ display: { xs: "block", sm: "none" } }} />
        </Box>
      ))}

      <Link component={RouterLink} to="/dashboard" sx={{ display: "inline-block", mt: 2 }}>
        戻る
      </Link>
    </Box>
  );
}